export function formatShipmentType(s: string | null | undefined) {
  if (!s) {
    return s;
  }

  if (s === 'I' || s === 'ID') {
    return 'ID';
  }
  if (s === 'D') {
    return 'D';
  }
  if (s === 'A.EDI') {
    return 'A.EDI';
  }

  return s
}

export function formatLclFcl(f:string|null|undefined) {
  if (f === 'L') {
    return 'Consol';
  } else if (f === 'F') {
    return 'FCL';
  } else if (f === 'O') {
    return 'LCL';
  }

  return f;
}

export function unFormatLclFcl(f:string|null|undefined) {
  if (f === 'Consol') {
    return 'L';
  } else if (f === 'FCL') {
    return 'F';
  } else if (f === 'LCL') {
    return 'O';
  }

  return '';
}

export function formatAEBlType(m:string|null|undefined) {
  let value = '';

  if (m === 'D') {
    value = 'Regular';
  } else if (m === 'C') {
    value = 'Consol';
  } else if (m === 'L') {
    value = 'Co-Load';
  }

  return value;
}
